var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.398,
    height: 27.02,
    viewBox: "0 0 34.398 27.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10756",
    "data-name": "Group 10756",
    transform: "translate(-41.322 -581.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10713",
    "data-name": "Group 10713",
    transform: "translate(48.7 581.489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14547",
    "data-name": "Rectangle 14547",
    width: 27.02,
    height: 27.02,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7228",
    "data-name": "Path 7228",
    d: "M271.034,183v2.2c1.285.068,4.567-.2,5.074,1.387h-5.074v1.962h5.311a3.216,3.216,0,0,1-2.5,1.827l-2.808.068L271,192.4l5.886,6.833h3.045l-5.548-6.8a5,5,0,0,0,4.7-3.992l2.131.068v-1.861h-2.3a3.129,3.129,0,0,0-.643-1.725h3.011V183Z",
    transform: "translate(-263.704 -177.938)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-upload-2218267",
    transform: "translate(41.322 586.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10708",
    "data-name": "Group 10708",
    transform: "translate(0.73 0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10707",
    "data-name": "Group 10707",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7230",
    "data-name": "Path 7230",
    d: "M219.98,208.325l.485-.535,1.164-1.286,1.408-1.554,1.216-1.343c.2-.216.4-.429.59-.651l.009-.009h-.785l.485.535,1.164,1.286,1.408,1.554,1.216,1.343c.2.217.387.44.59.651l.009.009a.559.559,0,0,0,.785,0,.567.567,0,0,0,0-.785l-.485-.535-1.164-1.286-1.408-1.554-1.216-1.343c-.2-.217-.387-.44-.59-.651l-.009-.009a.558.558,0,0,0-.785,0l-.485.535-1.164,1.286-1.408,1.554-1.216,1.343c-.2.216-.4.431-.59.651l-.009.009a.555.555,0,0,0,.785.785Z",
    transform: "translate(-219.037 -202)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10710",
    "data-name": "Group 10710",
    transform: "translate(5.595 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10709",
    "data-name": "Group 10709",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7231",
    "data-name": "Path 7231",
    d: "M481.956,202.232v12.736c0,.174,0,.346,0,.52v.022a.555.555,0,1,0,1.11,0V202.774c0-.174,0-.346,0-.52v-.022a.555.555,0,0,0-1.11,0Z",
    transform: "translate(-481.956 -201.677)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10712",
    "data-name": "Group 10712",
    transform: "translate(0 16.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10711",
    "data-name": "Group 10711",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7232",
    "data-name": "Path 7232",
    d: "M180.132,47.736h9.813c.452,0,.9.007,1.358,0h.019a.555.555,0,1,0,0-1.11h-9.813c-.451,0-.9-.007-1.358,0h-.018a.555.555,0,1,0,0,1.11Z",
    transform: "translate(-179.576 -46.622)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/Campaign.ad0b6be67149e8c19b965eab5c2c8ec0.svg";
export { ForwardRef as ReactComponent };